export const PAYMENT_PREFERENCES_DOCUMENT_NAME = 'payment';
export const COLLECTIONS_PREFERENCES_DOCUMENT_NAME = 'collections';
export const PREFERRED_PREFERENCES_COLLECTION_NAME = 'preferred';
